export function showElement(selector) {
    $(selector).removeClass('hidden');
}
export function hideElement(selector) {
    $(selector).addClass('hidden');
}
export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
function getBase64Image(data) {
    return data.replace(/^data:application\/octet-stream;base64,/, '');
}
export function openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
}
export function copyTextToClipboard(text) {
    var textArea = document.createElement('textarea');
    //
    // *** This styling is an extra step which is likely not required. ***
    //
    // Why is it here? To ensure:
    // 1. the element is able to have focus and selection.
    // 2. if element was to flash render it has minimal visual impact.
    // 3. less flakyness with selection and copying which **might** occur if
    //    the textarea element is not visible.
    //
    // The likelihood is the element won't even render, not even a
    // flash, so some of these are just precautions. However in
    // Internet Explorer the element is visible whilst the popup
    // box asking the user for permission for the web page to
    // copy to the clipboard.
    //
    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;
    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
    }
    catch (err) {
        console.log('Oops, unable to copy');
    }
    document.body.removeChild(textArea);
}
export function log(number, base) {
    if (base == null)
        base = Math.E;
    return Math.log(number) / Math.log(base);
}
export function round(val, digits) {
    digits = Math.pow(10, digits);
    return Math.floor(val * digits) / digits;
}
export function bytesToString(byteCount) {
    var suf = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
    if (byteCount.length === 0)
        return '0' + suf[0];
    var bytes = Math.abs(byteCount);
    var place = Math.floor(this.Log(bytes, 1024));
    var num = this.Round(bytes / Math.pow(1024, place), 1);
    return (Math.sign(byteCount) * num) + suf[place];
}
export function trimString(str) {
    if (!str)
        return str;
    return str.trim();
}
export function versionCompare(v1, v2, options) {
    var lexicographical = options && options.lexicographical, zeroExtend = options && options.zeroExtend, v1parts = v1.split('.'), v2parts = v2.split('.');
    function isValidPart(x) {
        return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
    }
    if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
        return NaN;
    }
    if (zeroExtend) {
        while (v1parts.length < v2parts.length)
            v1parts.push("0");
        while (v2parts.length < v1parts.length)
            v2parts.push("0");
    }
    if (!lexicographical) {
        v1parts = v1parts.map(Number);
        v2parts = v2parts.map(Number);
    }
    for (var i = 0; i < v1parts.length; ++i) {
        if (v2parts.length === i) {
            return 1;
        }
        if (v1parts[i] === v2parts[i]) {
            continue;
        }
        else if (v1parts[i] > v2parts[i]) {
            return 1;
        }
        else {
            return -1;
        }
    }
    if (v1parts.length !== v2parts.length) {
        return -1;
    }
    return 0;
}
export function isIE() {
    return /MSIE|Trident/.test(window.navigator.userAgent);
}
export function showUrl(url) {
    window.location.href = replaceSignsInUrl(url);
}
export function showUrlInBlank(url) {
    window.open(replaceSignsInUrl(url), '_blank');
}
export function replaceSignsInUrl(url) {
    return url.replace("&amp;", "&");
}
'api/v2/visual';
/** Очищает браузерное выделение текста */
export function clearTextSelection() {
    if (window.getSelection) {
        if (window.getSelection().empty) { // Chrome
            window.getSelection().empty();
        }
        else if (window.getSelection().removeAllRanges) { // Firefox
            window.getSelection().removeAllRanges();
        }
    }
    else if (document.selection) { // IE?
        document.selection.empty();
    }
}
export function getErrorMessage(response) {
    var errorMessage = "";
    if (response.message)
        errorMessage = response.message;
    else if (response.data)
        errorMessage = response.data;
    else if (response.statusText)
        errorMessage = response.status + " " + response.statusText;
    return errorMessage;
}
/** Возвращает объект Date из формата [dd.MM.yyyy] или null */
export function parseDate(str) {
    var split = str.split('.');
    var d = new Date(split[2], split[1], split[0]);
    return isValidDate(d) ? d : null;
}
/** Возвращает строку в формате [dd.MM.yyyy] из объекта Date */
export function getFormattedDate(d) {
    if (d == null)
        return null;
    var date = d.getDate();
    var month = d.getMonth();
    month++;
    var year = d.getFullYear();
    var res = formatTwoDigits(date) + "." + formatTwoDigits(month) + "." + year;
    return res;
}
export function isValidDate(d) {
    return d instanceof Date && isFinite(d);
}
export function formatTwoDigits(str) {
    str = str + "";
    if (str.length == 1) {
        str = "0" + str;
    }
    return str;
}
// "Сырой" шаблон для всплывающих сообщений об ошибках, чтобы получить шаблон для kendo необходимо заменить #=class# и #=style# на пустые строки или на дополнительные классы или атрибуты
export var ERR_MESSAGE_RAW_TPL = '<div class="k-widget k-tooltip k-tooltip-validation#=class#"#=attributes#><span class="k-icon k-warning"> </span>#=message#<div class="k-callout k-callout-n"></div><div class="close" title="Закрыть" onclick="this.parentNode.style.display=\'none\';">x</div></div>';
ERR_MESSAGE_RAW_TPL = ERR_MESSAGE_RAW_TPL;
// шаблон для kendo
export var ERROR_TEMPLATE = ERR_MESSAGE_RAW_TPL;
ERROR_TEMPLATE = ERROR_TEMPLATE.replace('#=class#', '');
ERROR_TEMPLATE = ERROR_TEMPLATE.replace('#=attributes#', '');
ERROR_TEMPLATE = ERROR_TEMPLATE;
// шаблон для самостоятельно подставляемых подсказок (serverValidation.js)
export var VALIDATION_MESSAGE_TPL = ERR_MESSAGE_RAW_TPL;
VALIDATION_MESSAGE_TPL = VALIDATION_MESSAGE_TPL.replace('#=class#', ' k-invalid-msg field-validation-error');
VALIDATION_MESSAGE_TPL = VALIDATION_MESSAGE_TPL.replace('#=attributes#', ' data-for="#=field#" data-valmsg-for="#=field#" id="#=field#_validationMessage"');
VALIDATION_MESSAGE_TPL = VALIDATION_MESSAGE_TPL;
// Отображает ошибки в модальном окне (требуется <div id="dialogErr"></div>).
// Т.е. если в качестве обработчика ошибок серверной валидации модальных окон стоит данный обработчик,
// то модальное окно редактирования закрывается и ошибки отображаются в другом модальном окне.
// Т.е. не подходит для серверной валидации. Нужен processErrors(grid, args).
export var ProcessGridErrors = function (e) {
    var text = 'Ошибка загрузки данных';
    if (e.errors) {
        var message = text + ':\n';
        $.each(e.errors, function (key, value) {
            if (value.errors) {
                message += value.errors.join('\n');
            }
        });
        this.ShowError(message);
    }
    else if (e.xhr) {
        this.ShowError(e.xhr.responseText, text);
    }
};
export function isNullOrEmpty(obj) {
    if (obj === undefined)
        return true;
    var str = obj.toString().trim();
    if ((!str && str !== false) || !(str.length > 0)) {
        return true;
    }
    return false;
}
export function stringToBoolean(string) {
    if (isNullOrEmpty(string))
        string = "false";
    switch (string.toLowerCase()) {
        case "true":
        case "yes":
        case "1": return true;
        case "false":
        case "no":
        case "0":
        case null: return false;
        default: return Boolean(string);
    }
}
export function indexOfStrInArray(arr, str) {
    var func = function (str1, str2) { return str1 == str2; };
    indexOfStrInArrayWFunc(arr, str, func);
}
export function isStrInArray(arr, str) {
    var func = function (str1, str2) { return str1 == str2; };
    return indexOfStrInArrayWFunc(arr, str, func) >= 0;
}
export function isStrInArrayWFunc(arr, str, func) {
    return indexOfStrInArrayWFunc(arr, str, func) >= 0;
}
/** Получить индекс строки в массиве. Через func задается сравнение строки и свойства в объекте массива.
 * @param {any} arr - массив объектов
 * @param {any} str - строка
 * @param {any} func - функция определения соответствия элемента массива и строки str  */
export function indexOfStrInArrayWFunc(arr, str, func) {
    var indexOfStr = -1;
    for (var i = 0; i < arr.length; i++) {
        if (func(arr[i], str)) {
            indexOfStr = i;
            break;
        }
    }
    return indexOfStr;
}
export function decode(value) {
    return value.replace(/&amp/g, '&amp;')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
}
export function parseHtml(text) {
    if ($.parseHTML) {
        return $($.parseHTML(text));
    }
    return $(text);
}
export function isEmptyArray(array) {
    return !(Array.isArray(array) && array.length);
}
export function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
export function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}
export function hexToBase64(hexString) {
    return btoa(hexString.match(/\w{2}/g).map(function (a) {
        return String.fromCharCode(parseInt(a, 16));
    }).join(""));
}
export function base64ToHex(b64string) {
    var buffer = Buffer.from(b64string, 'base64');
    return buffer.toString('hex');
}
export function getLocalDate(date) {
    return date ? date.toLocaleDateString() : '';
}
export function getValOrEmpty(val) {
    return val ? val : '';
}
export function getCommonName(subject) {
    return subject.G && subject.SN
        ? subject.SN + ' ' + subject.G
        : subject.CN;
}
export function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}
export function showIndicator(isEnabled, element) {
    element = element || 'body';
    kendo.ui.progress($(element), isEnabled);
}
